(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@foundit/ui-library"] = factory();
	else
		root["@foundit/ui-library"] = factory();
})(this, () => {
return 